import React from 'react'

const Error = () => {
  return (
    <div>404 not found</div>
  )
}

export default Error